import { render } from "./WinnerDoc.vue?vue&type=template&id=d1a4ea8e&scoped=true"
import script from "./WinnerDoc.vue?vue&type=script&lang=js"
export * from "./WinnerDoc.vue?vue&type=script&lang=js"

import "./WinnerDoc.vue?vue&type=style&index=0&id=d1a4ea8e&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1a4ea8e"]])

export default __exports__